import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import Header from "../components/Navbar/Header";
import useDebounce from "../hooks/useDebounce";
import { post } from "../utils/helpers/http";
import { useLocation } from "react-router-dom";

const getTimeSlot = (slot) => {
  switch (slot) {
    case 1:
      return "8am - 12pm";
    case 2:
      return "12pm - 4pm";
    case 3:
      return "4pm - 8pm";
    default:
      return "";
  }
};

function getStatusStyle(status) {
  switch (status) {
    case 1:
      return { backgroundColor: "#182774", color: "white" };
    case 2:
      return { backgroundColor: "#DA991A", color: "white" };
    case 3:
      return { backgroundColor: "#1979E9", color: "white" };
    case 4:
      return { backgroundColor: "#0A8F0F", color: "white" };
    case 5:
      return { backgroundColor: "#0FCC71", color: "white" };
    case 6:
      return { backgroundColor: "#8F8F8F", color: "white" };
    default:
      return { backgroundColor: "blue", color: "white" };
  }
}

const getOrderStatus = (orderStatus) => {
  switch (orderStatus) {
    case 1:
      return "New ";
    case 2:
      return "Order Collected";
    case 3:
      return "Delivered to LGo";
    case 4:
      return "Washing In Progress";
    case 5:
      return "Washing Complete";

    case 6:
      return "Out For Delivery";
    case 7:
      return "Delivered";
    default:
      return "New";
  }
};

const Manageorders = () => {
  const location = useLocation();

  const [orders, setOrders] = useState([]);
  // const [availableDrivers, setAvaibleDrivers] = useState([]);
  const [driverDropdownList, setDriverDropdownList] = useState([]);
  const [driverAvailableDate, setDriverAvailableDate] = useState(null);
  const [driverTimeSlot, setDriverTimeSlot] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);
  const [availableDrivers, setAvailableDrivers] = useState({});

  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    fetchOrders();
    availableDriverList();
  }, [
    debouncedSearchQuery,
    driverAvailableDate,
    driverTimeSlot,
    pageNo,
    pageSize,
  ]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idFromUrl = params.get("id");

    if (idFromUrl) {
      setSearchQuery(idFromUrl);
      setPageNo(1);
    }
  }, [location.search]);

  const availableDriverList = async (pickupDate, timeSlot, orderId) => {
    try {
      const response = await post("/Order/AvailableDriverList", {
        pickupDate,
        timeSlot,
      });

      setAvailableDrivers((prev) => ({
        ...prev,
        [orderId]: response.data.data || [],
      }));
    } catch (error) {
      setAvailableDrivers((prev) => ({ ...prev, [orderId]: [] }));
    }
  };

  const fetchOrders = async () => {
    setLoader(true);
    try {
      const response = await post("/Order/OrderList", {
        driverAvailableDate: driverAvailableDate
          ? driverAvailableDate + "T00:00:00.000Z"
          : null,
        driverTimeSlot,
        search: debouncedSearchQuery.trim(),
        pageNo,
        pageSize,
      });

      if (response.data.data) {
        const fetchedOrders = response.data.data.orders;
        setOrders(fetchedOrders);
        setDriverDropdownList(response.data.data.driverDropdownList);
        setTotalPages(response.data.data.totalRecords);

        // ✅ Har order ke liye onload drivers fetch karo
        fetchedOrders.forEach((order) => {
          if (order.orderStatus !== 7) {
            availableDriverList(
              order.pickUpDateTime,
              order.slot,
              order.orderId,
            );
          }
        });
      } else {
        setOrders([]);
        setTotalPages(0);
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setPageNo(1);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value?.trimStart();
    setSearchQuery(value);
    setPageNo(1);

    if (!value) {
      window.history.replaceState({}, "", location.pathname);
    }
  };

  const handleStatusChange = async (e, index) => {
    const { value } = e.target;
    const updatedOrders = [...orders];
    updatedOrders[index].status = value;
    setOrders(updatedOrders);

    const order = updatedOrders[index];
    const orderStatus =
      value === "In Progress" ? 4 : value === "Washing Complete" ? 5 : null;
    if (orderStatus) {
      try {
        await post(
          `/Order/ChangeOrderStatus?DriverId=${1}&OrderId=${order.orderId}&OrderStatus=${orderStatus}`,
          {
            formFile: null,
          },
        );
        toast.success("Order status updated successfully");
        fetchOrders();
      } catch (error) {}
    }
  };

  const handleDriverAssign = async (e, index, orderId) => {
    const { value } = e.target;
    try {
      await post("/Order/OrderDriverAssign", {
        orderId: orderId,
        driverId: value,
      });
      toast.success("Driver assigned successfully");
      fetchOrders();
    } catch (error) {}
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const closeModal = () => {
    setPreviewImage(null);
  };

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth d-flex align-items-center justify-content-between flex-wrap">
                  <h1 className="page-title me-3">Manage Orders</h1>
                </div>
              </div>
              <div className="page-content">
                <div className="table-filters">
                  <div className="left_filters">
                    <div className="filterBox">
                      <label className="form-filter-label">Show</label>
                      <select
                        className="form-filter form-select"
                        onChange={handlePageSizeChange}
                        value={pageSize}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                      </select>
                      <label className="ps-2">entries</label>
                    </div>
                  </div>
                  <div className="right_filters">
                    <div className="filtersearch me-3">
                      <label>Available Date:</label>
                      <input
                        type="date"
                        className="form-control me-3"
                        value={driverAvailableDate}
                        onChange={(e) => setDriverAvailableDate(e.target.value)}
                      />
                    </div>
                    <div className="filtersearch me-3">
                      <label>Available Time Slot:</label>
                      <select
                        className="form-control form-select"
                        value={driverTimeSlot}
                        onChange={(e) => setDriverTimeSlot(e.target.value)}
                      >
                        <option value={0}>All</option>
                        <option value={1}>8am - 12pm</option>
                        <option value={2}>12pm - 4pm</option>
                        <option value={3}>4pm - 8pm</option>
                      </select>
                    </div>
                    <div className="searchBox">
                      <label>Search:</label>
                      <input
                        type="text"
                        className="form-filter"
                        placeholder="Search by name, item, express"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-outerbox">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="20">Order ID</th>
                        <th>Order Item</th>
                        <th>Order Image</th>
                        <th>Customer Name</th>
                        <th width="250">Pick Up Address</th>
                        <th>Pick Up date</th>
                        <th>Slot</th>
                        <th className="text-center">Express Order</th>
                        <th>Status</th>
                        <th>Current Status</th>
                        <th>Driver</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.length
                        ? orders.map((order, index) => (
                            <tr key={index}>
                              <td>{order.orderId}</td>
                              <td className="wrapthis">
                                {order.orderItem || "-"}
                              </td>
                              <td className="wrapthis">
                                {order?.orderDocFilename ? (
                                  <div
                                    className="withImg"
                                    onClick={() =>
                                      setPreviewImage(order?.orderDocFilename)
                                    }
                                  >
                                    <img
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      src={order?.orderDocFilename}
                                      alt="Order Doc"
                                    />
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>{order.fullName}</td>
                              <td className="wrapthis">
                                {order.pickUpAddress}
                              </td>
                              <td>{formatDate(order.pickUpDateTime)}</td>

                              <td>{getTimeSlot(order.slot)}</td>
                              <td className="text-center">
                                {order.expressService === 0 ? "No" : "Yes"}
                              </td>
                              <td>
                                {order.orderStatus === 3 ||
                                order.orderStatus === 4 ? (
                                  <select
                                    value={
                                      order.orderStatus === 4
                                        ? "In Progress"
                                        : order.orderStatus === 5
                                          ? "Washing Complete"
                                          : "default"
                                    }
                                    onChange={(e) =>
                                      handleStatusChange(e, index)
                                    }
                                    className="form-control form-select"
                                  >
                                    <option value="default">--Select--</option>
                                    <option value="In Progress">
                                      In Progress
                                    </option>
                                    <option value="Washing Complete">
                                      Washing Complete
                                    </option>
                                  </select>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>

                              <td>
                                <span
                                  className="status"
                                  style={getStatusStyle(order.orderStatus)}
                                >
                                  {getOrderStatus(order.orderStatus)}
                                </span>{" "}
                              </td>

                              <td>
                                {order.orderStatus === 7 ? (
                                  order.driverName
                                ) : (
                                  <select
                                    onChange={(e) =>
                                      handleDriverAssign(
                                        e,
                                        index,
                                        order.orderId,
                                      )
                                    }
                                    value={order.driverId || "0"}
                                    className="form-control form-select"
                                  >
                                    <option value="0">--Assign Driver--</option>

                                    {order.driverId &&
                                      !(
                                        availableDrivers[order.orderId] || []
                                      ).find(
                                        (d) => d.id === order.driverId,
                                      ) && (
                                        <option value={order.driverId}>
                                          {order.driverName}
                                        </option>
                                      )}

                                    {(
                                      availableDrivers[order.orderId] || []
                                    ).map((driver) => (
                                      <option key={driver.id} value={driver.id}>
                                        {driver.fullName}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </td>
                            </tr>
                          ))
                        : null}
                      <tr>
                        {orders.length ? (
                          ""
                        ) : (
                          <td
                            colSpan="12"
                            style={{
                              textAlign: "center",
                              padding: "20px",
                              fontSize: "large",
                              fontWeight: "bold",
                            }}
                          >
                            No Data Found.
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="table-pagination">
                <div className="leftpart">
                  <span className="entriesdata">
                    Showing {(pageNo - 1) * pageSize + 1} to{" "}
                    {Math.min(pageNo * pageSize, orders?.length)} of{" "}
                    {totalPages} entries{" "}
                  </span>
                </div>
                <div className="rightpart">
                  {orders.length > 0 && (
                    <div className="pagination_box">
                      <ul>
                        <li className="prev">
                          <button
                            onClick={() => setPageNo(Math.max(pageNo - 1, 1))}
                          >
                            <i className="fa-solid fa-chevron-left"></i>{" "}
                            Previous
                          </button>
                        </li>
                        {[
                          ...Array(Math.ceil(totalPages / pageSize)).keys(),
                        ].map((page) => (
                          <li
                            key={page}
                            className={page + 1 === pageNo ? "current" : ""}
                          >
                            <button onClick={() => setPageNo(page + 1)}>
                              <span>{page + 1}</span>
                            </button>
                          </li>
                        ))}
                        <li className="next">
                          <button
                            onClick={() => {
                              const maxPage = Math.ceil(totalPages / pageSize);
                              if (pageNo < maxPage) {
                                setPageNo(pageNo + 1);
                              }
                            }}
                            disabled={
                              pageNo >= Math.ceil(totalPages / pageSize)
                            }
                          >
                            Next <i className="fa-solid fa-chevron-right"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <ToastContainer />
            </div>
            {/* {/ {loader && <Loader/>} /} */}
          </div>
          <Footer />
        </div>
      </div>

      {previewImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "-16px",
                right: "-16px",
                background: "white",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                fontSize: "30px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
              }}
            >
              ×
            </button>
            <img
              src={previewImage}
              alt="Order Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Manageorders;
